import { Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { convertFrom24ToAMPM } from './helper';

const branchServiceIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-branch-type-';
const contactIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-contact-';

const TimingsContacts = ({ data, t }) => {
  const contacts = data[0]?.fields?.items;
  const timings = data[1]?.fields?.items;

  const shouldRenderContacts = Array.isArray(contacts) && contacts.length > 0;
  const shouldRenderTimings = Array.isArray(timings) && timings.length > 0;

  return (
    <div className="timings-contacts">
      {shouldRenderTimings && (
        <div className="facility-timings">
          <div className="facility-header">{t('operatingHours')}</div>
          {timings.map((item, index) => {
            const title = item?.fields?.title;
            const type = item?.fields?.serviceType?.value;
            const items = item?.fields?.items;

            const shouldRenderTitle = !!title?.value;
            const shouldRenderItems = Array.isArray(items) && items.length > 0;
            return (
              <div key={index} className="facility-timings_type">
                <div className="facility-timings_type-header">
                  <div className="facility-timings_type-header_icon">
                    {type && (
                      <img
                        src={branchServiceIcon + type?.toLowerCase()?.replace(' ', '-')}
                        alt={type}
                      />
                    )}
                  </div>
                  <div className="facility-timings_type-header_content">
                    {shouldRenderTitle && <Text field={title} />}
                  </div>
                </div>
                {shouldRenderItems && (
                  <div className="facility-timings_type-body">
                    {items.map((item, index) => {
                      const startDay = item?.fields?.startDay?.fields?.DropdownText?.value;
                      const startTime = item?.fields?.startTime?.value;
                      const endDay = item?.fields?.endDay?.fields?.DropdownText?.value;
                      const endTime = item?.fields?.endTime?.value;
                      const isClosed = item?.fields?.isClosed?.value;
                      return (
                        <div key={index} className="facility-timings_type-body_content">
                          <div className="facility-timings_type-body_content-left">
                            {startDay && startDay}
                            {startDay && endDay && ' - '}
                            {endDay && `${endDay}`}
                          </div>
                          <div className="facility-timings_type-body_content-right">
                            {isClosed
                              ? t('closed')
                              : (startTime || endTime) &&
                                `
                                ${
                                  startTime &&
                                  convertFrom24ToAMPM(
                                    startTime.substring(0, 2),
                                    startTime.substring(2)
                                  )
                                }
                                ${startTime && endTime && ' - '}
                                ${
                                  endTime &&
                                  `${convertFrom24ToAMPM(
                                    endTime.substring(0, 2),
                                    endTime.substring(2)
                                  )}`
                                }
                              `}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      {shouldRenderContacts && (
        <div className="facility-contacts">
          <div className="facility-header">{t('contactInfo')}</div>
          {contacts.map((item, index) => {
            const contactInfo = item?.fields?.contactInfo;
            const type = item?.fields?.contactType?.value;
            return (
              type &&
              contactInfo?.value && (
                <div key={index} className="facility-contacts-body">
                  {type && (
                    <div className="facility-contacts-body_icon">
                      <img src={contactIcon + type?.toLowerCase()} alt={type} />
                    </div>
                  )}
                  {contactInfo?.value && (
                    <div className="facility-contacts-body_content">
                      <Text field={contactInfo} />
                    </div>
                  )}
                </div>
              )
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TimingsContacts;
